// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { action, makeObservable, observable } from 'mobx';

export class UiStore extends Store {
  public cookieConsentBannerEnabled;
  public navLoaded: boolean;
  public pageName: string;
  public osanoURL;
  public osanoUpdateLocale;
  public osanoLoaded: boolean;
  public supportedLocales;

  constructor(config, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    makeObservable(this, {
      cookieConsentBannerEnabled: observable,
      supportedLocales: observable,
      navLoaded: observable,
      pageName: observable,
      setNavLoaded: action,
      osanoURL: observable,
      osanoUpdateLocale: observable,
      osanoLoaded: observable,
      setOsanoLoaded: action,
      setPageName: action,
    });

    this.supportedLocales = config.app?.supportedLocales;

    this.navLoaded = false;

    this.cookieConsentBannerEnabled = config.app?.osano.enabled;
    this.osanoURL = config.app?.osano.url;
    this.osanoUpdateLocale = config.app?.osano.updateLocale;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setOsanoLoaded(loaded: boolean) {
    this.osanoLoaded = loaded;
  }

  public setNavLoaded(visible: boolean) {
    this.navLoaded = visible;
  }

  public setPageName(name: string) {
    this.pageName = name;
  }
}
